import type { FC } from 'react'

interface TabNavigationProps {
  activeTab: 'rhymes' | 'thesaurus'
  onTabChange: (tab: 'rhymes' | 'thesaurus') => void
}

/**
 * Tab navigation component for switching between Rhymes and Thesaurus
 */
export const TabNavigation: FC<TabNavigationProps> = ({ activeTab, onTabChange }) => {
  const tabClasses = (isActive: boolean) =>
    `flex-1 px-4 py-2 text-sm font-medium transition-colors ${
      isActive
        ? 'text-blue-600 border-b-2 border-blue-600'
        : 'text-gray-500 hover:text-gray-700'
    }`

  return (
    <div className="flex border-b border-gray-200 bg-white">
      <button
        data-testid="worksheet-tab-thesaurus"
        onClick={() => onTabChange('thesaurus')}
        className={tabClasses(activeTab === 'thesaurus')}
      >
        Thesaurus
      </button>
      <button
        data-testid="worksheet-tab-rhymes"
        onClick={() => onTabChange('rhymes')}
        className={tabClasses(activeTab === 'rhymes')}
      >
        Rhymes
      </button>
    </div>
  )
}
